<template>
  <div class="container flex flex-column items-center">
    <div class="container__item">
      <el-table
        :border="true"
        :data="tableData"
        class="article-list"
        :header-cell-style="{background: '#337ab7',color: '#ffffff',textAlign: 'center'}"
      >
        <el-table-column label="文章标题">
          <template slot-scope="scope">
            <router-link :to="{path:'detail',query:{id: scope.row.id, type: scope.row.typeId}}">{{ scope.row.title }}</router-link>
          </template>
        </el-table-column>
        <el-table-column prop="writeTime" label="发布日期" width="600"></el-table-column>
      </el-table>

      <el-pagination
      :page-size="pageDTO.limit"
      style="margin-top:30px;"
      background
      layout="total,prev, pager, next"
      :total="total"
      @current-change="handleClickPage"
    ></el-pagination>
    </div>
  </div>
</template>

<script>
import { getArticlePage } from "@/axios/front";
export default {
  data() {
    return {
      pageDTO: {
        page: 1,
        limit: 10,
        typeId: ""
      },
      tableData: [],
      total: 0
    };
  },
  methods: {
    handleGetArticlePage() {
      getArticlePage(this.pageDTO).then(res => {
        this.tableData = res.records;
        this.total = res.total
      });
    },
    handleClickPage(event) {
      this.pageDTO.page = event;
      this.handleGetArticlePage();
    }
  },
  mounted() {
    this.pageDTO.typeId = this.$route.query.type;
    this.handleGetArticlePage();
  },
  watch: {
    $route() {
      this.pageDTO.typeId = this.$route.query.type;
      this.handleGetArticlePage();
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  .article-list {
    width: 1200px;
  }
  &__item {
    margin-top: 50px;
    width: 1200px;
    height: auto;
    overflow-x: hidden;
  }
  width: 100%;
  height: auto;
}
</style>


// WEBPACK FOOTER //
// src/front/article/ArticleList.vue